// extracted by mini-css-extract-plugin
export var filterButton = "_pw-1";
export var filtersContainer = "_pw-0";